import { CalendarOutlined, FieldTimeOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { EmptyText, WordBreak } from '../../components/Common/CellText'
import FileItem from '../../components/Common/FileItemComponent/FileItem'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  DATE_FORMAT_DEFAULT,
  HHhMM,
} from '../../constants'
import utils from '../../utils'
import React from 'react'
import AccessControlAction from '../../components/AccessControlAction'
import { toJS } from 'mobx'
import { TaskInfoList } from '../MissionDetailPage/MissionDetailPageStyled'
import styled from 'styled-components'

const CustomTaskInfoList = styled(TaskInfoList)`
  dt {
    width: 170px;
  }
  dd {
    width: calc(100% - 175px);
  }
`

export const OfficeCalendarEventDetailItem = props => {
  const { label, value } = props || {}

  return (
    <>
      <dt>{label}</dt>
      <dd>{value}</dd>
    </>
  )
}

export const OfficeCalendarEventDetail = props => {
  const { workScheduleDetail, onDeleteEvent, onEditEvent } = props || {}

  const history = useHistory()

  const showPersonAndDate = (person, date) => {
    if (person) {
      return (
        <div>
          {`${utils.getNameInCapitalize(person)} - `}
          <span>{moment(date).format(DATE_FORMAT_DEFAULT)}</span>&nbsp;
          <span>{moment(date).format(HHhMM)}</span>
        </div>
      )
    }
    return <EmptyText>Chưa có thông tin</EmptyText>
  }

  const recipientNoticeList =
    workScheduleDetail?.assignees &&
    toJS(workScheduleDetail?.assignees).filter(
      el => el.permission === ASSIGNEE_TYPE.FOLLOWER
    )

  if (!workScheduleDetail) return null

  return (
    <>
      <h3
        style={{
          fontSize: 16,
          fontWeight: 'bold',
          marginBottom: 16,
        }}>
        Thông tin chung
      </h3>
      <CustomTaskInfoList>
        <OfficeCalendarEventDetailItem
          label="Thời gian"
          value={
            <>
              {workScheduleDetail?.start_at ? (
                <>
                  <CalendarOutlined style={{ marginRight: 4 }} />
                  <span>
                    {moment(workScheduleDetail?.start_at).format(
                      DATE_FORMAT_DEFAULT
                    )}
                  </span>
                  <FieldTimeOutlined
                    style={{ marginRight: 4, marginLeft: 16 }}
                  />
                  <span>
                    {moment(workScheduleDetail?.start_at).format(HHhMM)}
                  </span>
                </>
              ) : (
                <EmptyText>Không rõ.</EmptyText>
              )}
              {workScheduleDetail?.end_at && (
                <>
                  <span style={{ margin: '0 8px' }}>-</span>
                  <FieldTimeOutlined style={{ marginRight: 4 }} />
                  <span>
                    {moment(workScheduleDetail?.end_at).format(HHhMM)}
                  </span>
                </>
              )}
            </>
          }
        />
        <OfficeCalendarEventDetailItem
          label="Chủ trì"
          value={workScheduleDetail?.host || <EmptyText>Không rõ.</EmptyText>}
        />
        <OfficeCalendarEventDetailItem
          label="Địa điểm"
          value={
            workScheduleDetail?.location ? (
              WordBreak(utils.urlify(workScheduleDetail?.location), true)
            ) : (
              <EmptyText>Không rõ.</EmptyText>
            )
          }
        />
        <OfficeCalendarEventDetailItem
          label="Chuẩn bị"
          value={
            workScheduleDetail?.preparation ? (
              WordBreak(utils.urlify(workScheduleDetail?.preparation), true)
            ) : (
              <EmptyText>Không có chuẩn bị.</EmptyText>
            )
          }
        />
        <OfficeCalendarEventDetailItem
          label="Nội dung sự kiện"
          value={
            workScheduleDetail?.event_notice ? (
              WordBreak(workScheduleDetail?.event_notice, true)
            ) : (
              <EmptyText>Không có nội dung sự kiện.</EmptyText>
            )
          }
        />
        <OfficeCalendarEventDetailItem
          label="Tài liệu đính kèm"
          value={
            workScheduleDetail.file_ids?.length ? (
              workScheduleDetail.file_ids.map(file => (
                <FileItem
                  key={file.file_id}
                  file_id={file.file_id}
                  file_name={file.file_title}
                  file_type={utils.getExtensionFile(file.file_title)}
                />
              ))
            ) : (
              <EmptyText>Không có tài liệu đính kèm.</EmptyText>
            )
          }
        />
        <OfficeCalendarEventDetailItem
          label="Thành viên tham gia"
          value={
            workScheduleDetail?.attenders ? (
              workScheduleDetail?.attenders
            ) : (
              <EmptyText>Không có thành viên tham gia.</EmptyText>
            )
          }
        />
        <OfficeCalendarEventDetailItem
          label="Thông báo"
          value={
            recipientNoticeList?.length > 0 ? (
              <span>
                {recipientNoticeList
                  ?.map(el => utils.getNameInCapitalize(el.name_uppercase))
                  .join(', ')}
              </span>
            ) : (
              <EmptyText>Không có người nhận thông báo.</EmptyText>
            )
          }
        />
        <OfficeCalendarEventDetailItem
          label="Ngày tạo"
          value={showPersonAndDate(
            workScheduleDetail?.assignees?.find(
              user => user.permission === ASSIGNEE_TYPE.CREATE
            )?.name_uppercase,
            workScheduleDetail?.created_at
          )}
        />
        <OfficeCalendarEventDetailItem
          label="Chỉnh sửa lần cuối"
          value={showPersonAndDate(
            workScheduleDetail?.last_edit_by?.name_lowercase,
            workScheduleDetail?.updated_at
          )}
        />
      </CustomTaskInfoList>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 16,
          marginTop: 24,
        }}>
        <AccessControlAction
          aclActionType={ACL_ACTION_TYPE.delete__WORK_SCHEDULE}>
          <Button
            danger
            size="large"
            style={{ borderRadius: 8 }}
            className="w-160"
            onClick={() => onDeleteEvent(workScheduleDetail?.schedule_code)}>
            Xóa
          </Button>
        </AccessControlAction>
        <AccessControlAction
          aclActionType={ACL_ACTION_TYPE.edit__WORK_SCHEDULE}>
          <Button
            type="primary"
            size="large"
            style={{ borderRadius: 8 }}
            className="w-160"
            onClick={() => onEditEvent(workScheduleDetail?.schedule_code)}>
            Chỉnh sửa
          </Button>
        </AccessControlAction>
      </div>
    </>
  )
}
